import { CONTENT_WIDTH, DATE_FORMATS } from "@/enums";
import { ISelectOption } from "@/interfaces";
import { Input, Select, UploadFile, UploadProps } from "antd";
import { useIntl } from "react-intl";
import * as Styled from "../styled";
import { InitiativeDocumentsUpload } from "./InitiativeDocumentsUpload";

interface IInitiativeFormFieldsProps {
  projectTypeOptions: ISelectOption[];
  productCategoryOptions: ISelectOption[];
  fileList: UploadFile[];
  initiativePublicId: string | undefined;
  placeholderId: string;
  beforeUpload: UploadProps["beforeUpload"];
  onRemove: UploadProps["onRemove"];
  onChange: UploadProps["onChange"];
  onPreview: UploadProps["onPreview"];
}

export const InitiativeFormFields = ({
  projectTypeOptions,
  productCategoryOptions,
  fileList,
  initiativePublicId,
  placeholderId,
  beforeUpload,
  onRemove,
  onChange,
  onPreview,
}: IInitiativeFormFieldsProps): React.JSX.Element => {
  const intl = useIntl();

  return (
    <Styled.SectionRow justify="start">
      <Styled.SectionHeaderItem>
        {intl.formatMessage({ id: "initiative.requiredFields" })}
      </Styled.SectionHeaderItem>
      <Styled.FieldsColumn
        xxl={CONTENT_WIDTH.oneQuarter}
        xl={CONTENT_WIDTH.oneThird}
        lg={CONTENT_WIDTH.half}
        xs={CONTENT_WIDTH.max}
      >
        <Styled.FieldsCard
          size="small"
          title={intl.formatMessage({ id: "initiative.keyInformation" })}
          $required
        >
          <Styled.FormItem
            label={intl.formatMessage({ id: "initiative.opportunityName" })}
            name="name"
            rules={[
              {
                required: true,
                message: intl.formatMessage({
                  id: "general.fieldRequiredMessage",
                }),
              },
            ]}
          >
            <Input />
          </Styled.FormItem>
          <Styled.FormItem
            label={intl.formatMessage({ id: "projects.projectType" })}
            name="projectType"
            rules={[
              {
                required: true,
                message: intl.formatMessage({
                  id: "general.fieldRequiredMessage",
                }),
              },
            ]}
          >
            <Select options={projectTypeOptions} />
          </Styled.FormItem>
          <Styled.FormItem
            label={intl.formatMessage({ id: "projects.productCategory" })}
            name="productCategory"
            rules={[
              {
                required: true,
                message: intl.formatMessage({
                  id: "general.fieldRequiredMessage",
                }),
              },
            ]}
          >
            <Select options={productCategoryOptions} />
          </Styled.FormItem>
          <InitiativeDocumentsUpload
            fileList={fileList}
            initiativePublicId={initiativePublicId}
            placeholderId={placeholderId}
            beforeUpload={beforeUpload}
            onRemove={onRemove}
            onChange={onChange}
            onPreview={onPreview}
          />
          <Styled.FormItem
            label={intl.formatMessage({ id: "initiative.estimatedTargetLaunchDate" })}
            name="estimatedTargetLaunchDate"
            rules={[
              {
                required: true,
                message: intl.formatMessage({
                  id: "general.fieldRequiredMessage",
                }),
              },
            ]}
          >
            <Styled.EstimatedLaunchDatePicker
              format={DATE_FORMATS.fourDigitYear}
              placeholder={DATE_FORMATS.fourDigitYear}
              data-test-id="initiative-estimated-launch-date-date-picker"
            />
          </Styled.FormItem>
        </Styled.FieldsCard>
      </Styled.FieldsColumn>
    </Styled.SectionRow>
  );
};

export default InitiativeFormFields;
